import * as React from "react";
import { Spinner, SpinnerSize, Link } from "@fluentui/react";
import Layout from "./Layout";
import PropTypes from "prop-types";

export default function SplashView({ text }) {
  return (
    <Layout
      header={
        <div className="splash__header">
          <img src={require("./../../../assets/xm-logo.png")} alt={"XMReality logo"} />
        </div>
      }
      content={<Spinner size={SpinnerSize.large} label={text} />}
      footer={
        <Link className="ms-fontSize-16" href="https://xmreality.com" underline={false}>
          xmreality.com
        </Link>
      }
    />
  );
}

SplashView.propTypes = {
  text: PropTypes.string,
};
